import type { CompanyNavId } from "./nav-math";

/** Desk primary nav classes — underline active, not pill dump — plan/35. */
export function deskNavClass(active: boolean): string {
  return [
    "shrink-0 border-b-2 px-3 py-2.5 text-sm no-underline transition-colors",
    active
      ? "border-[var(--color-foreground)] font-medium text-[var(--color-foreground)]"
      : "border-transparent text-[var(--color-muted)] hover:border-[var(--color-border)] hover:text-[var(--color-foreground)]",
  ].join(" ");
}

export function deskMoreItemClass(active: boolean): string {
  return [
    "block rounded-lg px-3 py-2.5 text-sm no-underline transition-colors",
    active
      ? "bg-[var(--color-background)] font-medium text-[var(--color-foreground)]"
      : "text-[var(--color-muted)] hover:bg-[var(--color-background)] hover:text-[var(--color-foreground)]",
  ].join(" ");
}

function pathEqualsOrChild(pathname: string, base: string): boolean {
  return pathname === base || pathname.startsWith(`${base}/`);
}

/**
 * Which primary desk item owns this URL — plan/35.
 * Inventory must not steal Convert; Sales owns queues under /sales/*.
 */
export function deskPrimaryNavActive(
  id: CompanyNavId,
  pathname: string,
  companySlug: string,
): boolean {
  const root = `/c/${companySlug}`;
  switch (id) {
    case "home":
      // Exact company index only — do not steal /c/:slug/sales etc.
      return pathname === root || pathname === `${root}/`;
    case "pos":
      return pathEqualsOrChild(pathname, `${root}/pos`);
    case "sales":
      return pathEqualsOrChild(pathname, `${root}/sales`);
    case "returns":
      return pathEqualsOrChild(pathname, `${root}/returns`);
    case "purchasing":
      return pathEqualsOrChild(pathname, `${root}/purchasing`);
    case "products":
      return pathEqualsOrChild(pathname, `${root}/products`);
    case "inventory":
      // Exact on-hand list only — convert is its own primary item.
      return pathname === `${root}/inventory` || pathname === `${root}/inventory/`;
    case "convert":
      return pathEqualsOrChild(pathname, `${root}/inventory/convert`);
    case "trialBalance":
      return (
        pathname === `${root}/gl/trial-balance` ||
        pathname === `${root}/gl/trial-balance/`
      );
    default:
      return false;
  }
}

/** True when the current path belongs to a More-menu destination. */
export function deskMoreNavActive(
  morePaths: readonly string[],
  pathname: string,
): boolean {
  return morePaths.some((base) => pathEqualsOrChild(pathname, base));
}
